
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/ColorPicker.html",
      function () {
        return require("private-next-pages/Forms/ColorPicker.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/ColorPicker.html"])
      });
    }
  